import { render } from "./CryptoPage.vue?vue&type=template&id=0470a439&ts=true"
import script from "./CryptoPage.vue?vue&type=script&lang=ts"
export * from "./CryptoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__